/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { Minter } from "./Minter";

export class MinterFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<Minter> {
    return super.deploy(overrides || {}) as Promise<Minter>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): Minter {
    return super.attach(address) as Minter;
  }
  connect(signer: Signer): MinterFactory {
    return super.connect(signer) as MinterFactory;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Minter {
    return new Contract(address, _abi, signerOrProvider) as Minter;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "PerpMinted",
    type: "event",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getPerpToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "inflationMonitor",
    outputs: [
      {
        internalType: "contract IInflationMonitor",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_perpToken",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "insuranceFund",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_amount",
        type: "tuple",
      },
    ],
    name: "mintForLoss",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "mintReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "rewardsDistribution",
    outputs: [
      {
        internalType: "contract RewardsDistribution",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IInflationMonitor",
        name: "_inflationMonitor",
        type: "address",
      },
    ],
    name: "setInflationMonitor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_insuranceFund",
        type: "address",
      },
    ],
    name: "setInsuranceFund",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract RewardsDistribution",
        name: "_rewardsDistribution",
        type: "address",
      },
    ],
    name: "setRewardsDistribution",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract SupplySchedule",
        name: "_supplySchedule",
        type: "address",
      },
    ],
    name: "setSupplySchedule",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "supplySchedule",
    outputs: [
      {
        internalType: "contract SupplySchedule",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
